import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  EventEmitter,
  Output,
  NgModule,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Document } from 'src/app/shared/models/document';
import { NotificationService } from '../../services/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import {
  DxFileUploaderModule,
  DxButtonModule,
  DxPopupModule,
  DxProgressBarModule,
} from 'devextreme-angular';
import { MsTooltipModule } from '../ms-tooltip/ms-tooltip.component';
import { DocumentService } from '../../services/documet/document.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { PharmacyService } from 'src/app/shared/services/user/pharmacy.service';
import { ThisReceiver } from '@angular/compiler';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
})
export class DocumentUploadComponent implements OnInit, OnChanges {
  @Input() showDelete: boolean;
  @Input() context: any;
  @Input() listingId: number;
  @Input() companyId: string;
  @Input() facilityId: string;
  @Input() stateLicense: string;
  @Input() deaLicense: string;
  @Input() updateLicenseinDB: boolean = false;
  @Input() orderId: string;
  @Input() type: string;
  @Input() limit: number = 1;
  @Input() listingImage: string;
  @Input() listingImageUrl: string;
  @Input() email: string;
  @Input() documents: Document[] = [];
  @Input() disabled: boolean;
  @Input() preview = false;
  @Input() allowedFileExtensions = [
    '.pdf',
    '.jpg',
    '.jpeg',
    '.png',
    '.PDF',
    '.JPG',
    '.JPEG',
    '.PNG',
  ];
  @Input() persistUploadButton = false;
  @Input() disableUpload = false;
  @Output() update = new EventEmitter<boolean>();
  @Output() licenseModalClosed = new EventEmitter<boolean>();
  allowedFileExtensionsAllCases: any[] = [];

  filteredDocuments: any[] = [];

  filesToUpload: any[] = [];
  isDragOver = false;
  @ViewChild('nativeFileInput') nativeFileInput: ElementRef<HTMLInputElement>;

  askDeleteVisible = false;

  selectedDocument: any;

  isProcessing = false;
  progressValue = 0;
  processMessage = '';
  canCloseProcessing = false;
  progressInterval: any;
  apiTimeout: any;

  constructor(
    private sanitizer: DomSanitizer,
    private documentService: DocumentService,
    private notifyService: NotificationService,
    private sessionService: SessionService,
    private pharmacyService: PharmacyService,
    private posthogService: PosthogService,
  ) {}

  ngOnInit() {
    this.getReadebleExtentions();
    this.getDocuments();
    this.filteredDocuments = [];
  }

  private getReadebleExtentions() {
    this.allowedFileExtensionsAllCases = this.allowedFileExtensions.map(
      extension => extension.toLowerCase(),
    );
    this.allowedFileExtensionsAllCases =
      this.allowedFileExtensionsAllCases.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const facilityIdChange = changes['facilityId'];
    if (typeof facilityIdChange?.previousValue !== 'undefined') {
      this.getDocuments();
    }
  }

  getDocuments() {
    const search = {
      context: this.context,
      type: this.type,
    };

    if (this.context === 'listing' && this.type !== 'global_listing') {
      search['listing_id'] = this.listingId;
    } else if (this.context === 'listing' && this.type === 'global_listing') {
      search['company_id'] = this.companyId;
    } else if (this.context === 'company' && this.type === 'open_document') {
      search['company_id'] = this.companyId;
    } else if (this.context === 'profile') {
      search['company_id'] = this.companyId;
    } else if (this.context === 'order') {
      search['order_id'] = this.orderId;
    } else if (this.context === 'facility') {
      search['facility_id'] = this.facilityId;
      search['company_id'] = this.companyId;
    }

    this.documentService.get(search).subscribe(
      result => {
        this.documents = result.data;
        this.disabled =
          this.documents.length &&
          this.context === 'facility' &&
          ['terms_pdf', 'state_license', 'reseller_certificate'].includes(
            this.type,
          );
        this.filterDocuments();
      },
      error => {
        this.notifyService.showNotify(error, 'error');
      },
    );
  }

  private emitPrimaryFacilityUpdatedTrigger() {
    if (this.context !== 'facility' || !this.facilityId) {
      this.sessionService.primaryFacilityUpdatedTrigger.next(true);
      return;
    }
    this.pharmacyService.getPharmacy(this.facilityId).subscribe(
      result => {
        this.sessionService.primaryFacilityUpdatedTrigger.next(true);
      },
      error => {
        this.sessionService.primaryFacilityUpdatedTrigger.next(true);
      },
    );
  }

  documentURL(url): SafeResourceUrl {
    if (url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    return null;
  }

  filterDocuments() {
    this.filteredDocuments = this.documents.filter(
      document => document.type === this.type,
    );
    if (this.limit) {
      this.filteredDocuments = this.filteredDocuments.slice(0, this.limit);
    }
    return this.filteredDocuments;
  }

  documentCurrentDelete() {
    this.askDeleteVisible = false;
    this.documentService.delete(this.selectedDocument.id).subscribe(
      (response: any) => {
        if (['Calibration_File'].includes(response.data.type)) {
          this.notifyService.showNotify('History File was deleted.', 'success');
        } else {
          this.notifyService.showNotify('Document was deleted.', 'success');
        }
        this.getDocuments();
        this.update.emit(true);
      },
      error => {
        this.notifyService.showNotify(error, 'error');
      },
    );
  }

  documentOpen = document => window.open(document.url, '_blank').focus();

  sanitizeFileName(name: string) {
    // spaces to dashes
    let sanitized = name.replace(/\s+/g, '-');
    // remove special characters
    sanitized = sanitized.replace(/[^a-zA-Z0-9._-]/g, '');
    sanitized = sanitized.toLowerCase();
    return sanitized;
  }

  uploadFile() {
    if (!this.filesToUpload.length) {
      return;
    }
    const extension = this.filesToUpload[0].name.split('.').pop();

    if (!this.allowedFileExtensions.includes(`.${extension}`)) {
      this.notifyService.showNotify('This file type is not supported', 'error');
      this.filesToUpload = [];
      return;
    }

    const formData = new FormData();
    const sanitizedFileName = this.sanitizeFileName(this.filesToUpload[0].name);

    var params = {};
    if (this.context === 'listing' && this.type !== 'global_listing') {
      params['listing_id'] = this.listingId;
    } else if (this.context === 'profile') {
      params['company_id'] = this.companyId;
    } else if (this.context === 'order') {
      params['order_id'] = this.orderId;
    } else if (this.context === 'derma') {
      params['email'] = this.email;
      params['product'] = 'scarpack';
    } else if (
      this.context === 'facility' &&
      [
        'state_license',
        'reseller_certificate',
        'Calibration_File',
        'terms_pdf',
        'dea_license',
      ].includes(this.type)
    ) {
      params['facility_id'] = this.facilityId;
      params['company_id'] = this.companyId;
      params['state_license'] = this.stateLicense;
      params['dea_license'] = this.deaLicense;
      params['update_license_in_db'] = this.updateLicenseinDB;
    } else if (
      this.context === 'facility' &&
      this.type !== 'terms_pdf' &&
      'Calibration_File' &&
      'state_license'
    ) {
      params['facility_id'] = this.facilityId;
    } else if (this.context === 'company' && this.type === 'open_document') {
      params['company_id'] = this.companyId;
    } else if (this.context === 'listing' && this.type === 'global_listing') {
      params['company_id'] = this.companyId;
    }
    params['context'] = this.context;
    params['type'] = this.type;
    formData.append('params', JSON.stringify(params));
    formData.append('doc', this.filesToUpload[0], sanitizedFileName);

    this.isProcessing = true;
    this.progressValue = 0;
    this.processMessage = 'Please wait while your upload is processed';
    this.canCloseProcessing = false;

    // Simulate progress over 20 seconds
    const totalDuration = 20000; // 20 seconds
    const intervalTime = 100; // update every 100ms
    const step = 100 / (totalDuration / intervalTime);

    this.progressInterval = setInterval(() => {
      if (this.progressValue < 95) { // Cap at 95% until done
        this.progressValue += step;
      }
    }, intervalTime);

    this.apiTimeout = setTimeout(() => {
      clearInterval(this.progressInterval);
      this.progressValue = 100;
      this.processMessage = 'The license was not able to be automatically processed.';
      this.canCloseProcessing = true;
    }, totalDuration);

    this.documentService.upload(formData).subscribe(
      (response: any) => {
        // Clear timeout and interval on response
        clearTimeout(this.apiTimeout);
        clearInterval(this.progressInterval);
        this.progressValue = 100;
        this.canCloseProcessing = true;

        this.filesToUpload = [];
        this.getDocuments();

        if (['state_license', 'dea_license'].includes(this.type)) {
          const parseResponse = response.data?.ai_parse_response?.data;

          if (parseResponse?.valid) {
            if (parseResponse.updated_state_license_expiration || parseResponse.updated_dea_license_expiration) {
              const newExpiry = parseResponse.updated_state_license_expiration || parseResponse.updated_dea_license_expiration;
              this.processMessage = `License verified and expiration date updated to ${newExpiry}.`;
              this.update.emit(true);
            } else if (parseResponse.existing_license_number_mismatch) {
              this.processMessage = `License verified but the license number does not match our records. Manual verification required.`;
              this.update.emit(true);
            } else if (parseResponse.facility_and_license_address_mismatch) {
              this.processMessage = `License verified but the address does not match our records. This will be manually reviewed within 48 hours.`;
              this.update.emit(true);
            } else {
              this.processMessage = `License uploaded and verified.`;
              this.update.emit(true);
            }
            this.posthogService.capture('license_uploaded', {
              valid: true,
              message: this.processMessage,
            });
          } else if (parseResponse && !parseResponse.valid) {
            this.processMessage = `License could not be automatically verified: ${parseResponse.reason || 'Unknown reason'}. It has been queued for manual review.`;
            this.update.emit(true);
            this.posthogService.capture('license_uploaded', {
              valid: false,
              rejection_reason: parseResponse.reason || 'Unknown reason',
              message: this.processMessage,
            });
          } else {
            this.processMessage = 'License has been uploaded and will be processed within the next 48 hours.';
            this.update.emit(true);
            this.posthogService.capture('license_uploaded', {
              valid: false,
              rejection_reason: 'queued_for_manual_review',
              message: this.processMessage,
            });
          }
          this.emitPrimaryFacilityUpdatedTrigger();
        } else if (['Calibration_File'].includes(this.type)){
          this.processMessage = 'History File Successfully Uploaded.';
          this.update.emit(true);
        } else {
          // For non-license uploads, just close or show simpler message if needed.
          // But requirement was mainly for licenses. We'll reuse the logic or just set success.
          this.processMessage = 'Document was uploaded successfully.';
          this.update.emit(true);
        }
      },
      error => {
        clearTimeout(this.apiTimeout);
        clearInterval(this.progressInterval);
        this.progressValue = 100;
        this.canCloseProcessing = true;
        this.processMessage = 'An error occurred during upload.';
        this.notifyService.showNotify(error, 'error');
      },
    );
  }

  closeProcessingModal() {
    this.isProcessing = false;
    this.progressValue = 0;
    this.processMessage = '';
    this.canCloseProcessing = false;
    this.licenseModalClosed.emit(true);
  }

  askDelete(document) {
    this.selectedDocument = document;
    this.askDeleteVisible = true;
  }

  noClick() {
    this.askDeleteVisible = false;
  }

  // ── Drag-and-Drop Handlers ──────────────────
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const extension = '.' + file.name.split('.').pop();
      if (!this.allowedFileExtensions.includes(extension) &&
          !this.allowedFileExtensions.includes(extension.toUpperCase())) {
        this.notifyService.showNotify('This file type is not supported', 'error');
        return;
      }
      this.filesToUpload = [file];
      this.uploadFile();
    }
  }

  onNativeFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.filesToUpload = [input.files[0]];
      // Reset so the same file can be re-selected next time
      input.value = '';
      this.uploadFile();
    }
  }

  triggerFileSelect() {
    this.nativeFileInput?.nativeElement?.click();
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxPopupModule,
    DxProgressBarModule,
    MsTooltipModule,
    RouterModule,
  ],
  declarations: [DocumentUploadComponent],
  exports: [DocumentUploadComponent],
})
export class DocumentUploadModule {}
